import { Button } from "../index";

/**
 * ButtonSave — botão de submissão "Salvar" baseado no componente Button.
 *
 * @param {boolean}        [isLoading]   - Exibe spinner e desabilita o botão durante loading. Default: false.
 * @param {React.ReactNode}[children]    - Conteúdo do botão. Default: "Salvar".
 * @param {string}         [loadingText] - Texto exibido durante o estado de loading. Default: "Salvando...".
 * @param {object}         props         - Demais props repassados ao Button (type, onClick, className, etc.).
 */
const ButtonSave = ({
  isLoading = false,
  children = "Salvar",
  loadingText = "Salvando...",
  ...props
}) => {
  return (
    <Button variant="primary" isLoading={isLoading} {...props}>
      {isLoading ? loadingText : children}
    </Button>
  );
};

export default ButtonSave;
